/* Material UI */
import { MenuItem, TextField } from '@mui/material';
import { DateTime, Info } from 'luxon';
import PropTypes from 'prop-types';
/* Standard */
import React from 'react';

/* Shared Components & Business Logic */
import useStyles from './styles';

/* Component */
const QDateSelect = (props) => {
  /* Prop Types */
  QDateSelect.propTypes = {
    styleProps: PropTypes.object,
    monthValue: PropTypes.string,
    yearValue: PropTypes.number,
    menuStartYear: PropTypes.number,
    numberYears: PropTypes.number,
    handleChangeMonth: PropTypes.func,
    handleChangeYear: PropTypes.func,
    yearOnly: PropTypes.bool,
    monthLabel: PropTypes.string,
    yearLabel: PropTypes.string,
  };

  /* Helper Functions */
  // This function renders list of years based on date passed as parameter
  const renderYearList = (date, numYears = 50) => {
    const yearList = [];
    for (let i = 0; i < numYears; i++) {
      yearList.push(date.plus({ years: i }).year);
    }
    return yearList.map((year) => (
      <MenuItem key={year} value={year}>
        {' '}
        {year}{' '}
      </MenuItem>
    ));
  };
  // This function renders list of all months
  const renderMonthList = () =>
    Info.months('short').map((month) => (
      <MenuItem key={month} value={month}>
        {month}
      </MenuItem>
    ));
  /* Component Level Variables */
  const { classes } = useStyles();
  const {
    monthValue,
    yearValue,
    handleChangeMonth,
    handleChangeYear,
    styleProps,
    menuStartYear,
    numberYears,
    yearOnly,
    monthLabel,
    yearLabel,
  } = props;
  /* Component Render */
  return (
    <div style={{ ...styleProps }} className={classes.parentDiv}>
      {!yearOnly && (
        <TextField
          style={{ marginRight: 4 }}
          id='outlined-select-date-month'
          select
          value={monthValue}
          onChange={(e) => handleChangeMonth(e.target.value)}
          variant='filled'
          fullWidth
          label={monthLabel}
          helperText=' '
          classes={{
            root: classes.selectItem,
          }}
          SelectProps={{
            MenuProps: {
              classes: {
                paper: classes.scrollMenu,
              },
              MenuListProps: { id: 'outlined-select-date-month-menu' },
            },
          }}
        >
          {renderMonthList()}
        </TextField>
      )}
      <TextField
        style={{ marginLeft: 4 }}
        id='outlined-select-date-year'
        select
        // children={renderYearList(DateTime.local())}
        value={yearValue}
        onChange={(e) => handleChangeYear(e.target.value)}
        variant='filled'
        label={yearLabel}
        helperText=' '
        fullWidth
        classes={{
          root: classes.selectItem,
        }}
        SelectProps={{
          MenuProps: {
            classes: {
              paper: classes.scrollMenu,
            },
            MenuListProps: { id: 'outlined-select-date-year-menu' },
          },
        }}
      >
        {renderYearList(menuStartYear ? DateTime.fromObject({ year: menuStartYear }) : DateTime.local(), numberYears)}
      </TextField>
    </div>
  );
}; // end component

export default QDateSelect;
